import Button from "../../atomic/Button";
import type { NavItemComponentProps } from "./types";
import { useNavbarContext } from "./NavbarContext";

export function Logo({ item }: NavItemComponentProps) {
  const { navigateFromSource } = useNavbarContext();
  const { branding, source } = item;
  const logoSrc = branding?.logo;
  const altText =
    branding?.altText ?? branding?.clientName ?? item.label ?? "Logo";

  const handleClick = () => {
    if (source) {
      navigateFromSource(source);
    }
  };

  const label = branding?.clientName ?? item.label;

  if (!logoSrc) {
    if (!source) {
      return (
        <span
          className="text-sm font-semibold"
          style={{ color: "var(--navbar-text)" }}
        >
          {label}
        </span>
      );
    }
    return (
      <Button
        onClick={handleClick}
        className="border-0 !bg-transparent p-0 text-sm font-semibold shadow-none"
        style={{ color: "var(--navbar-text)" }}
      >
        {label}
      </Button>
    );
  }

  if (!source) {
    return <img className="h-6 w-auto" src={logoSrc} alt={altText} />;
  }

  return (
    <Button
      onClick={handleClick}
      className="flex flex-shrink-0 items-center border-0 !bg-transparent p-0 shadow-none"
      aria-label={altText}
    >
      <img className="h-6 w-auto" src={logoSrc} alt={altText} />
    </Button>
  );
}
